export const technicianSelectConfig = {
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 150,
            sorter: true,
        },
        {
            title: "Имя",
            dataIndex: "firstName",
            key: "firstName",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Фамилия",
            dataIndex: "lastName",
            key: "lastName",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Отчество",
            dataIndex: "middleName",
            key: "middleName",
            sorter: true,
            ellipsis: true,
            render: (middleName) => middleName || "—",
        },
        {
            title: "Телефон",
            dataIndex: "phone",
            key: "phone",
            sorter: true,
            width: 150,
            render: (phone) => phone || "—",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sorter: true,
            ellipsis: true,
            render: (email) => email || "—",
        },
    ],
    rowKey: "id",
    pagination: {
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} техников`,
    },
};
export const serviceVehicleSelectConfig = {
    rowKey: "id",
    columns: [
        {
            title: "Гос. номер",
            dataIndex: "licensePlate",
            key: "licensePlate",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Марка",
            dataIndex: "brand",
            key: "brand",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Модель",
            dataIndex: "model",
            key: "model",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Статус",
            dataIndex: "status",
            key: "status",
            sorter: true,
            width: 120,
            render: (status) => status,
        },
        {
            title: "Пробег (км)",
            dataIndex: "currentMileageKm",
            key: "currentMileageKm",
            sorter: true,
            width: 120,
            render: (value) => value?.toLocaleString(),
        },
    ],
    pagination: {
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} автомобилей`,
    },
};
export const chargingStationSelectConfig = {
    rowKey: "id",
    columns: [
        {
            title: "Серийный номер",
            dataIndex: "serialNumber",
            key: "serialNumber",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Статус",
            dataIndex: "status",
            key: "status",
            sorter: true,
            width: 120,
            render: (status) => status,
        },
        {
            title: "Текущий заряд (кВт⋅ч)",
            dataIndex: "currentChargeLevel",
            key: "currentChargeLevel",
            sorter: true,
            width: 150,
            render: (value) => (value ? `${value} кВт⋅ч` : "—"),
        },
        {
            title: "Сессий зарядки",
            dataIndex: "totalChargingSessions",
            key: "totalChargingSessions",
            sorter: true,
            width: 120,
            render: (value) => value?.toLocaleString() || "—",
        },
        {
            title: "Доставлено (кВт⋅ч)",
            dataIndex: "totalKwhDelivered",
            key: "totalKwhDelivered",
            sorter: true,
            width: 150,
            render: (value) => (value ? `${value} кВт⋅ч` : "—"),
        },
    ],
    pagination: {
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} станций`,
    },
};
